// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Layout_mainContainer__3wFoP"};